import MyFlightUpdates from '@/views/MyFlightUpdates/index.vue'

const MyFlightUpdatesRouter = {
  path: '/my-flight-updates',
  name: 'MyFlightUpdates',
  component: MyFlightUpdates,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default MyFlightUpdatesRouter
